module.exports = __webpack_public_path__ + "static/img/图层590灰底.cfef69fc.png";